<template>
  <div v-if="team" class="card">
    <!-- Team Card -->
    <b-card
      :class="team.my_team == '1' && 'my-team-bg'"
      v-if="team.points"
      class="shadow-none"
    >
      <b-link
        style="text-decoration:none"
        :to="{ path: '/team/' + team.team_id }"
      >
        <div class=" d-flex align-items-center pl-1">
          <span class=" h5 text-terciary font-weight-bold mr-3">
            {{ team.rank }}.
          </span>
          <div style="width:fit-content">
            <b-img-lazy
              class="rounded-circle  "
              style="object-fit: cover;"
              height="50"
              width="50"
              center
              :src="`${team.file_path}${team.file_name}`"
              alt=""
            />
          </div>

          <div class="d-flex ml-4  text-terciary flex-grow-1 text-box">
            <span class=" font-weight-normal size " v-if="team.name">
              {{ team.name }}
            </span>

            <!-- Points -->

            <span v-if="team.points" class="size points">
              {{ team.points }} p
            </span>
          </div>
        </div>
      </b-link>
    </b-card>

    <!-- Individual Card -->
    <b-card
      :class="team.my_user == '1' && 'my-team-bg'"
      v-else-if="team.points_balance"
      class="shadow-none"
    >
      <div class=" d-flex align-items-center pl-1">
        <span class=" h5 text-terciary font-weight-bold mr-3">
          {{ team.rank }}.
        </span>
        <div style="width:fit-content">
          <b-img-lazy
            class="rounded-circle  "
            style="object-fit: cover;"
            height="50"
            width="50"
            center
            v-if="team.file_path && team.file_name"
            :src="`${team.file_path}${team.file_name}`"
            alt=""
          />
          <b-avatar v-else style="background:#999999" size="50"
            ><small>{{ team.initials }}</small></b-avatar
          >
        </div>

        <div class="d-flex ml-4 text-terciary flex-grow-1 text-box">
          <!-- Name -->
          <span class=" font-weight-normal" v-if="team.full_name">
            {{ team.full_name }}
          </span>

          <!-- Points -->
          <span v-if="team.points_balance"> {{ team.points_balance }} p </span>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  props: ["team"],
}
</script>

<style scoped>
.card >>> .card-body {
  padding: 0.68rem 1.2rem !important;
}
.my-team-bg {
  background: #F0E07D;
}
.text-box {
  flex-direction: row;
  justify-content: space-between;
}
.size {
  font-size: 13px;
}
@media (max-width: 360px) {
  .text-box {
    flex-direction: column;
  }
  /* .text-box .points{
            text-align: right;
          } */
}
@media (min-width: 1200px) {
  .size {
    font-size: 15px;
  }
}
</style>
